export default {
  buttons: {
    start: 'Începeți pregătirea comenzii programate',
  },
};
